export const defaultValues = {
  laboratoryId: undefined,
  providerId: null,
  productsByLoincItems: [],
  additionalProductIds: [],
  diagnosisIds: [],
  patientIds: [],
};
